import React from "react";
import { Instagram, Heart, MessageCircle } from "lucide-react";
import { SHOP } from "@/lib/api";
import { SmartImage } from "@/components/SmartImage";

// Curated crochet flower content matching @sugandhiflowermerchant Instagram aesthetic
const IMAGES = [
  "https://images.unsplash.com/photo-1494972308805-463bc619d34e?auto=format&fit=crop&q=80&w=600",
  "https://images.unsplash.com/photo-1518895949257-7621c3c786d7?auto=format&fit=crop&q=80&w=600",
  "https://images.unsplash.com/photo-1470509037663-253afd7f0f51?auto=format&fit=crop&q=80&w=600",
  "https://images.unsplash.com/photo-1520763185298-1b434c919102?auto=format&fit=crop&q=80&w=600",
  "https://images.unsplash.com/photo-1485955900006-10f4d324d411?auto=format&fit=crop&q=80&w=600",
  "https://images.unsplash.com/photo-1459411552884-841db9b3cc2a?auto=format&fit=crop&q=80&w=600",
  "https://images.unsplash.com/photo-1494972308805-463bc619d34e?auto=format&fit=crop&q=80&w=600&sat=-50",
  "https://images.unsplash.com/photo-1518895949257-7621c3c786d7?auto=format&fit=crop&q=80&w=600&sat=50",
  "https://images.unsplash.com/photo-1470509037663-253afd7f0f51?auto=format&fit=crop&q=80&w=600&sat=20",
  "https://images.unsplash.com/photo-1520763185298-1b434c919102?auto=format&fit=crop&q=80&w=600&sat=-20",
  "https://images.unsplash.com/photo-1485955900006-10f4d324d411?auto=format&fit=crop&q=80&w=600&sat=30",
  "https://images.unsplash.com/photo-1459411552884-841db9b3cc2a?auto=format&fit=crop&q=80&w=600&sat=-30",
];

export const GalleryPage = () => {
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-10 pb-24 md:pb-16" data-testid="gallery-page">
      <div className="text-center mb-8">
        <div className="inline-flex items-center gap-2 px-3 py-1 bg-[#FCE4EC] rounded-full text-[#D81B60] text-xs font-bold">
          <Instagram size={14} /> {SHOP.instagramHandle}
        </div>
        <h1 className="font-serif text-4xl sm:text-5xl text-[#2D0A22] mt-3">From our Instagram</h1>
        <p className="text-[#8E6377] mt-2">Loved by {SHOP.followers} followers — bouquets in the wild.</p>
        <a href={SHOP.instagram} target="_blank" rel="noreferrer" data-testid="gallery-follow-button"
          className="mt-4 inline-flex items-center gap-2 pill-btn">
          <Instagram size={16} /> Follow @sugandhiflowermerchant
        </a>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-1.5 sm:gap-2">
        {IMAGES.map((src, i) => (
          <a
            key={i} href={SHOP.instagram} target="_blank" rel="noreferrer"
            data-testid={`gallery-item-${i}`}
            className="group relative aspect-square overflow-hidden rounded-md sm:rounded-lg"
          >
            <SmartImage
              src={src}
              alt={`Sugandhi Flowers post ${i + 1}`}
              width={600}
              widths={[240, 400, 600, 800]}
              sizes="(max-width: 640px) 50vw, 33vw"
              aspectRatio="1/1"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-[#2D0A22]/50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-4 text-white">
              <span className="flex items-center gap-1 text-sm font-semibold"><Heart size={16} fill="currentColor" /> {80 + i * 7}</span>
              <span className="flex items-center gap-1 text-sm font-semibold"><MessageCircle size={16} /> {6 + i}</span>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};
